export default {
  messages: Object
}
